export default {
  messages: Object
}
